export const BASE_URL="https://tourmanagementplatform-b.onrender.com/api/v1";
